export const purpleBg =
  "https://deliverr.com/wp-content/themes/deliverr/images/freight/bg-shadow01.png";
